import { Device } from "@services/devices/types";

export const isLinkOk = ({ status }: Pick<Device, "status">): boolean =>
  status?.reachable === true && status?.stale !== true;
export const isLinkError = ({ status }: Pick<Device, "status">): boolean =>
  status?.reachable === false && status?.stale !== true;
export const isProvisioned = ({
  provisioned,
}: Pick<Device, "provisioned">): boolean => provisioned ?? false;
export const isLinkUnknown = (
  device: Pick<Device, "status" | "provisioned">
): boolean =>
  !isLinkOk(device) && !isLinkError(device) && isProvisioned(device);

export const isLoginOk = ({
  status,
  apiSupported,
}: Pick<Device, "status" | "apiSupported">): boolean =>
  status !== undefined &&
  Object.keys(status).length > 0 &&
  status.stale !== true &&
  (status.apiError ?? "").length === 0 &&
  (status.loginError ?? "").length === 0 &&
  apiSupported === true &&
  status?.loginUnknown !== true;
export const isLoginError = ({ status }: Pick<Device, "status">): boolean =>
  status !== undefined &&
  (status?.loginError ?? "").length > 0 &&
  status.stale !== true &&
  status?.loginUnknown !== true;
export const isLoginUnknown = (
  device: Pick<Device, "status" | "apiSupported">
): boolean => !isLoginOk(device) && !isLoginError(device);

export const isApiOk = ({
  status,
  apiSupported,
}: Pick<Device, "status" | "apiSupported">): boolean =>
  status !== undefined &&
  Object.keys(status).length > 0 &&
  (status.apiError ?? "").length === 0 &&
  status.stale !== true &&
  apiSupported === true &&
  status.apiUnknown !== true;
export const isApiError = ({ status }: Pick<Device, "status">): boolean =>
  status !== undefined &&
  (status?.apiError ?? "").length > 0 &&
  status.stale !== true &&
  status.apiUnknown !== true;
export const isApiUnknown = (
  device: Pick<Device, "status" | "apiSupported">
): boolean => !isApiError(device) && !isApiOk(device);

export interface IDeviceStatusSummary {
  api: { ok: number; error: number; unknown: number };
  login: { ok: number; error: number; unknown: number };
  link: { ok: number; error: number; unknown: number };
}
export const getSummary = (devices: Device[]): IDeviceStatusSummary =>
  devices.reduce(
    (acc, device) => {
      acc.api.ok += isApiOk(device) ? 1 : 0;
      acc.api.error += isApiError(device) ? 1 : 0;
      acc.api.unknown += isApiUnknown(device) ? 1 : 0;
      acc.login.ok += isLoginOk(device) ? 1 : 0;
      acc.login.error += isLoginError(device) ? 1 : 0;
      acc.login.unknown += isLoginUnknown(device) ? 1 : 0;
      acc.link.ok += isLinkOk(device) ? 1 : 0;
      acc.link.error += isLinkError(device) ? 1 : 0;
      acc.link.unknown += isLinkUnknown(device) ? 1 : 0;
      return acc;
    },
    {
      api: { ok: 0, error: 0, unknown: 0 },
      login: { ok: 0, error: 0, unknown: 0 },
      link: { ok: 0, error: 0, unknown: 0 },
    }
  );
